module.exports = __webpack_public_path__ + "static/media/warning-small.f5fbe853.svg";